import { render, staticRenderFns } from "./DeleteListConfirmation.vue?vue&type=template&id=37375cec"
import script from "./DeleteListConfirmation.ts?vue&type=script&lang=ts&external"
export * from "./DeleteListConfirmation.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports